import { render, staticRenderFns } from "./warning-orange.vue?vue&type=template&id=7031c3f4&functional=true"
import script from "./warning-orange.vue?vue&type=script&lang=js"
export * from "./warning-orange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports